import ViewLeadEstateAdminstration from "./viewleadEstateAdminStration"
import ViewLeadGrantApplication from "./viewleadGrantApplication"
import ViewLeadLastingPowersOfAttorney from "./viewleadlasting-powers-of-attorney"
import ViewLeadConveyancing from "./viewleadConveyancing"
import { useParams } from "react-router-dom"

export default function ViewLeads() {
    const { slug } = useParams();
  return (
    <>
          {slug === "estate-administration" && <ViewLeadEstateAdminstration />}
          {slug === "grant-application" && <ViewLeadGrantApplication />}
          {slug === "lasting-powers-of-attorney" && <ViewLeadLastingPowersOfAttorney/>}
          {slug === "conveyancing" && <ViewLeadConveyancing />}
        </>
  )
}
